import { IAnalyticsRepository } from 'repositories/AnalyticsRepository/interfaces';

export class AnalyticsService {
    private matomo: IAnalyticsRepository;

    private gAnalytics: IAnalyticsRepository;

    public init = (matomo: IAnalyticsRepository, gAnalytics: IAnalyticsRepository) => {
        this.matomo = matomo;
        this.gAnalytics = gAnalytics;
    };

    public trackStandings = (place: string) => {
        // this.matomo?.trackStandings(place);
        this.gAnalytics?.trackStandings(place);
    };

    public trackBoTabSelection = (tabName: string) => {
        // this.matomo?.trackBoTabSelection(tabName);
        this.gAnalytics?.trackBoTabSelection(tabName);
    };

    public trackSound = (status: string) => {
        this.matomo?.trackSound(status);
        this.gAnalytics?.trackSound(status);
    };

    public trackOpenHTP = () => {
        // this.matomo?.trackOpenHTP();
        this.gAnalytics?.trackOpenHTP();
    };

    public trackMultiPlaceBet = (page: string) => {
        // this.matomo?.trackMultiPlaceBet(page);
        this.gAnalytics?.trackMultiPlaceBet(page);
    };

    public trackB2cOpen = (source: string) => {
        this.gAnalytics?.trackB2cOpen(source);
    };

    public trackMatchInfo = (source: string) => {
        this.gAnalytics?.trackMatchInfo(source);
    };

    public trackProfileOpen = () => {
        this.gAnalytics?.trackProfileOpen();
    };

    public trackMyBetsOpen = (source: string) => {
        this.gAnalytics?.trackMyBetsOpen(source);
    };

    public trackParticipantsOpen = () => {
        this.gAnalytics?.trackParticipantsOpen();
    };

    public trackBetSlipTypeTabs = (betSlipTypeTabName: string) => {
        this.gAnalytics?.trackBetSlipTypeTabs(betSlipTypeTabName);
    };

    public trackBetSlipComponent = (betSlipComponent: string) => {
        this.gAnalytics?.trackBetSlipComponent(betSlipComponent);

        this.gAnalytics?.trackBetSlipLocation(
            window.location.hash.includes('match') ? 'match' : 'tournament',
        );
    };

    public trackMatchNavigation = (matchNavigation: string) => {
        this.gAnalytics?.trackMatchNavigation(matchNavigation);
    };

    public trackFullscreen = (fullscreenStatus: string) => {
        this.gAnalytics?.trackFullscreen(fullscreenStatus);
    };

    public trackReplay = () => {
        this.gAnalytics?.trackReplay();
    };

    public trackParticipantOpen = () => {
        this.gAnalytics?.trackParticipantOpen();
    };

    public trackParticipantsFilter = (filter: string | number) => {
        this.gAnalytics?.trackParticipantsFilter(filter);
    };

    public trackChangeRoute = (pathName: string) => {
        this.gAnalytics?.trackChangeRoute(pathName);
    };

    public trackGui = (guiStatus: boolean) => {
        this.gAnalytics.trackGui(guiStatus);
    };

    public trackStandingsMetaInfo = (type: string) => {
        this.gAnalytics.trackStandingsMetaInfo(type);
    };

    public trackAmountButton = () => {
        this.matomo?.trackAmountButton();
    };

    public trackPlaceBet = (uuid: string) => {
        this.matomo?.trackPlaceBet(uuid);
    };
}
